import { formatAmountAsPerTheCoinUnit } from "src/utils/formatAmountAsPerTheCoinUnit";
import { getSubAccountFinancialsReport } from "./API";
import { HASHRATE, convertTo, getHashrateUnit } from 'src/api/HashrateFormatter';
import { applySorting, getComparator } from "src/utils/filterAndSortData";
import dayjs from "dayjs";

const formatHashrate = hashrate => {
  const hashrateUnit = getHashrateUnit(hashrate, HASHRATE.GHS);
  return hashrateUnit.formatToHashrateString((hashrate * HASHRATE.GHS.one).toFixed(3));
}

const GetSubAccountFinancialsReport = async (startDate, endDate, subAccounts, timeInterval, accessToken) => {
  try {
    const { data } = await getSubAccountFinancialsReport(startDate, endDate, subAccounts, timeInterval, accessToken);
      const financialReportData = data.subAccountStats.flatMap(acct => {
      return applySorting(acct.subAccountStats.map(stat => {
          return {
            ...stat,
            startDate: dayjs(stat.startDate).utcOffset(stat.startDate.slice(-6)).format('YYYY-MM-DD HH:mm:ss'),
            endDate: dayjs(stat.endDate).utcOffset(stat.endDate.slice(-6)).format('YYYY-MM-DD HH:mm:ss'),
            earningsCreditTime: timeInterval === "byDay" ? dayjs(stat.earningsCreditTime).utcOffset(stat.earningsCreditTime.slice(-6)).format('YYYY-MM-DD HH:mm:ss'): null,
            hashrate: formatHashrate(stat.hashrateAccepted),
            convertedHashrate: convertTo(stat.hashrateAccepted, HASHRATE.GHS, HASHRATE.THS),
            groupName: acct.groupName,
            subAccountName: acct.subAccountName,
            feeRatePercent: stat.feeRatePercent,
            poolFeeAmount: formatAmountAsPerTheCoinUnit('BTC', stat.poolFeeAmount),
            ppsBaseAmount: formatAmountAsPerTheCoinUnit('BTC', stat.ppsBaseAmount),
            txFeeRewardAmount: formatAmountAsPerTheCoinUnit('BTC', stat.txFeeRewardAmount),
            earned: formatAmountAsPerTheCoinUnit('BTC', stat.earned),
            withdrawn: formatAmountAsPerTheCoinUnit('BTC', stat.withdrawn),
            grossEarnings: formatAmountAsPerTheCoinUnit('BTC', stat.grossEarnings),
            balance: formatAmountAsPerTheCoinUnit('BTC', stat.balance)
          }
        }), getComparator('desc', 'startDate'))
    })
    const totals =  applySorting(data.totalSubAccountStats.map(stat => {
          return {
            ...stat,
            startDate: dayjs(stat.startDate).utcOffset(stat.startDate.slice(-6)).format('YYYY-MM-DD HH:mm:ss'),
            hashrate: convertTo(stat.hashrateAccepted, HASHRATE.GHS, HASHRATE.THS),
            ppsBaseAmount: formatAmountAsPerTheCoinUnit('BTC', stat.ppsBaseAmount),
            txFeeRewardAmount: formatAmountAsPerTheCoinUnit('BTC', stat.txFeeRewardAmount),
            earned: formatAmountAsPerTheCoinUnit('BTC', stat.earned),
            withdrawn: formatAmountAsPerTheCoinUnit('BTC', stat.withdrawn),
            poolFeeAmount: formatAmountAsPerTheCoinUnit('BTC', stat.poolFeeAmount),
            grossEarnings: formatAmountAsPerTheCoinUnit('BTC', stat.grossEarnings),
            balance: formatAmountAsPerTheCoinUnit('BTC', stat.balance)
          }
        }), getComparator('desc', 'startDate'))
    return { success: true, data: financialReportData, totals };
  } catch (error) {
    return { 
      success: false,
      data: error?.response?.data?.message
        ? error?.response?.data?.message
        : 'Error: Error getting report data.'
    };
  }
};

export default GetSubAccountFinancialsReport;